import { Form, Formik, FormikProps } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { PATH } from '../../../constants';
import { loginSchema } from '../../../schema/login.schema';
import { SubmitForm } from '../../../utils/submit-form.util';
import SocialButton from '../../button/social.button';
import Button from '../../button/v2/button';
import Container from '../../containers/container';
import { HStack, VStack } from '../../layouts/stack.layout';
import Text from '../../typography/v2/text';
import IconTextFormGroup from '../inputs/icon-text.formGroup';

const styles = {
  'form-overlay':
    'w-full z-20 h-[220px] absolute top-0 rounded-t-lg left-0 bg-black/10 backdrop-blur-sm',
  'form-wrapper':
    'bg-[#171718] relative w-full mobile:px-3 mobile:py-10 tablet-sm:px-6 tablet-sm:py-16 rounded-lg',
  'form-group__link-text':
    'self-end font-text text-right font-light text-sm text-primary border-b border-transparent hover:border-white',
};

type LoginFormType = {
  password: string;
  email: string;
};

export default function LoginForm({ alt }: { alt?: boolean }) {
  const initialValues = {
    email: '',
    password: '',
  };
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={loginSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        await SubmitForm.signUpForm(values, setSubmitting);
        navigate(PATH.HOME);
      }}
    >
      {(formik: FormikProps<LoginFormType>) => (
        <Form className={`relative w-full ${styles['form-wrapper']}`}>
          {alt && <Container extensions={styles['form-overlay']} />}
          <VStack gap="base">
            <IconTextFormGroup
              placeholder="Email"
              name="email"
              type="text"
              label="email"
              icon="mail"
            />
            <IconTextFormGroup
              placeholder="Password"
              label="password"
              name="password"
              type="password"
              icon="locked"
            />
          </VStack>
          <VStack extensions="mt-2 w-full" gap="md">
            <Link
              className="w-full flex justify-end"
              to={`/${PATH.AUTH}/${PATH.RESET_PASSWORD}`}
            >
              <div className={styles['form-group__link-text']}>
                Forgot Password
              </div>
            </Link>

            {alt ? (
              <Button
                onClick={() => {
                  navigate(`/${PATH.AUTH}/${PATH.SIGN_UP}`);
                }}
                width="full"
                text="Sign Up With Email"
              />
            ) : (
              <Button
                type="submit"
                width="full"
                text="login"
                color="secondary"
                disabled={verify(formik.touched, formik.errors)}
              />
            )}

            <Text align="center">Or continue with your socials</Text>
            <HStack extensions="w-2/3 mx-auto" justify="around">
              <SocialButton social="spotify" />
              <SocialButton social="google" />
              <SocialButton social="twitter" />
            </HStack>
          </VStack>
        </Form>
      )}
    </Formik>
  );
}

const verify = (touched: any, errors: any): boolean => {
  if (!touched.email || !touched.password) return true;
  return errors.email || errors.password;
};
